import moment from "moment";


export function parseTimeWithUserTimezone (time) {
    return moment(time).utcOffset(new Date(time).getTimezoneOffset(), true).format("LLL");
}